/* tslint:disable */
/* eslint-disable */
/**
 * Rapurc API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LocalizedValue,
    LocalizedValueFromJSON,
    LocalizedValueFromJSONTyped,
    LocalizedValueToJSON,
    Metadata,
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './';

/**
 * Hazardous material object
 * @export
 * @interface HazardousMaterial
 */
export interface HazardousMaterial {
    /**
     * 
     * @type {string}
     * @memberof HazardousMaterial
     */
    readonly id?: string;
    /**
     * Localized hazardous material names
     * @type {Array<LocalizedValue>}
     * @memberof HazardousMaterial
     */
    localizedNames: Array<LocalizedValue>;
    /**
     * EWC (European Waste Code) category ID
     * @type {string}
     * @memberof HazardousMaterial
     */
    wasteCategoryId: string;
    /**
     * Last two characters of EWC (European Waste Code) code
     * @type {string}
     * @memberof HazardousMaterial
     */
    ewcSpecificationCode: string;
    /**
     * 
     * @type {Metadata}
     * @memberof HazardousMaterial
     */
    metadata: Metadata;
}

export function HazardousMaterialFromJSON(json: any): HazardousMaterial {
    return HazardousMaterialFromJSONTyped(json, false);
}

export function HazardousMaterialFromJSONTyped(json: any, ignoreDiscriminator: boolean): HazardousMaterial {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'localizedNames': ((json['localizedNames'] as Array<any>).map(LocalizedValueFromJSON)),
        'wasteCategoryId': json['wasteCategoryId'],
        'ewcSpecificationCode': json['ewcSpecificationCode'],
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function HazardousMaterialToJSON(value?: HazardousMaterial | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'localizedNames': ((value.localizedNames as Array<any>).map(LocalizedValueToJSON)),
        'wasteCategoryId': value.wasteCategoryId,
        'ewcSpecificationCode': value.ewcSpecificationCode,
        'metadata': MetadataToJSON(value.metadata),
    };
}


